import  { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoader from '../../../../components/PageLoader';
import { useAppDispatch } from '../../../../hooks/hooks';
import { channelPrograms } from '../../../../redux/channel-program/action';
import { dodProgramParticipants } from '../../../../redux/dod-program-participants/action';
import { selectDodProgramParticipantsListItems } from '../../../../redux/dod-program-participants/selector';
import { selectChannelProgramsListItems } from '../../../../redux/channel-program/selector';
import GlobalShipxAgencyComponent from '../components/global-shipx-agency-component';
import { shipxAgencyMappings } from '../../../../redux/shipx-agency-mappings/action';
import { selectShipxMappingQueryItems } from '../../../../redux/shipx-agency-mappings/selector';

const GlobalShipXAgencyMapping  = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const GlobalShipXAgencyMappingQuery = useSelector(selectShipxMappingQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
    const participantsData = useSelector(selectDodProgramParticipantsListItems)
      const itemsData = useSelector(selectChannelProgramsListItems)
  const [
    selectedGlobalShipXMapping,
    setSelectedGlobalShipXMapping
  ] = useState<any>({})


  const fetchChannelProgramById = () => {
     dispatch(shipxAgencyMappings.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-ShipX-agency-mappings/fetch-detail`,
      entity: 'shipxAgencyMappings',
      jsonData: {
        Context:{},
        Records: [
          {
            Id: parmas?.id,
           
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGlobalShipXMapping({ ...selectedGlobalShipXMapping, [field]: event });
  }

  useEffect(
    () => {
       
                      dispatch(channelPrograms.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/fetch`,
      entity: 'channelPrograms',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ]
      }
    })).then(() => {
        dispatch(dodProgramParticipants.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-shipx-program-participants/fetch`,
      entity: 'dodProgramParticipants',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ],
        Pagination:{
      }
      }
    }))})

            if (parmas?.id > 0) {
                fetchChannelProgramById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedGlobalShipXMapping(GlobalShipXAgencyMappingQuery?.result?.items)
      }
    },
    [isQuery]
  )

 

  const back = () => {
    navigate(`/dbn/global-shipx-agency-mapping`)
  }


  return (
    <>
      {isLoading ? <PageLoader /> :
        <GlobalShipxAgencyComponent
          selectedGlobalShipXMapping={selectedGlobalShipXMapping}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
           dodProgramParticipants={participantsData?.result?.items}
            channelPrograms={itemsData?.result?.items}
            id={parmas?.id}
        />
      }
    </>
  )

}

export default GlobalShipXAgencyMapping ;